<template>
    <div>
        <div v-if="data.type === 'bloodtest'" class="item-container">
            <div class="bloodtest-color">
                {{ data.values.date | time }}
            </div>

            <div>
                <img src="@/assets/icons/analitica_icon.svg" />
            </div>

            <div>
                <label class="form-label">{{ bloodTestFields.fviii_c.label }}:</label>
                {{ data.values.fviii_c | valueOrEmpty }} <span v-if="data.values.fviii_unit">{{ data.values.fviii_unit }}</span>
            </div>
            <div>
                <label class="form-label">{{ bloodTestFields.fviii_cr.label }}:</label>
                {{ data.values.fviii_cr | valueOrEmpty }} <span v-if="data.values.fviii_unit">{{ data.values.fviii_unit }}</span>
            </div>
            <div>
                <label class="form-label">{{ bloodTestFields.hemoglobin.label }}:</label>
                {{ data.values.hemoglobin | valueOrEmpty }} <span>{{ bloodTestFields.hemoglobin.help_text }}</span>
            </div>
            <div>
                <label class="form-label">{{ bloodTestFields.platelets.label }}:</label>
                {{ data.values.platelets | valueOrEmpty }} <span>{{ bloodTestFields.platelets.help_text }}</span>
            </div>

            <div v-if="data.values.id" class="buttons">
            <span class="float-right mr-3">
                <i
                    class="fas fa-trash clickable"
                    @click="$bvModal.show(modalDeleteId)"
                />
            </span>
                <span class="float-right mr-3">
                <i
                    class="fas fa-pen clickable"
                    @click="$bvModal.show(modalId)"
                />
            </span>
            </div>
        </div>

        <div v-if="data.type === 'transfusion'" class="item-container">
            <div class="transfusion-color">
                {{ data.values.date | time }}
            </div>

            <div>
                <img src="@/assets/icons/transfusion_icon.svg" />
            </div>

            <div>
                <label class="form-label">{{ transfusionFields.amount.label }}:</label>
                {{ data.values.amount | valueOrEmpty }} <span>{{ transfusionFields.amount.help_text }}</span>
            </div>
            <div>
                <label class="form-label">{{ transfusionFields.transfusion_type.label }}:</label>
                {{ data.values.transfusion_type | choice(transfusionFields.transfusion_type) }}
            </div>

            <div v-if="data.values.id" class="buttons">
            <span class="float-right mr-3">
                <i
                    class="fas fa-trash clickable"
                    @click="$bvModal.show(modalDeleteId)"
                />
            </span>
                <span class="float-right mr-3">
                <i
                    class="fas fa-pen clickable"
                    @click="$bvModal.show(modalId)"
                />
            </span>
            </div>
        </div>

        <div v-if="data.type === 'novoeighttreatment'" class="item-container">
            <div class="novoeighttreatment-color">
                {{ data.values.date | time }}
            </div>

            <div>
                <img src="@/assets/icons/novoeight_icon.svg" />
            </div>

            <div>
                <label class="form-label">{{ novoeightTreatmentFields.total_dose.label }}:</label>
                {{ data.values.total_dose | valueOrEmpty }}
                <span>{{ novoeightTreatmentFields.total_dose.help_text }}</span>
            </div>
            <div>
                <label class="form-label">{{ novoeightTreatmentFields.reason.label }}:</label>
                {{ data.values.reason | choice(novoeightTreatmentFields.reason) | valueOrEmpty }}
            </div>
            <div>
                <label class="form-label">{{ novoeightTreatmentFields.administration.label }}:</label>
                {{ data.values.administration | choice(novoeightTreatmentFields.administration) | valueOrEmpty }}
                <span v-if="data.values.administration === 'continuous_infusion'">
                    ({{ data.values.administration_infusion }}
                    {{ novoeightTreatmentFields.administration_infusion.help_text }})
                </span>
            </div>

            <div v-if="data.values.id" class="buttons">
            <span class="float-right mr-3">
                <i
                    class="fas fa-trash clickable"
                    @click="$bvModal.show(modalDeleteId)"
                />
            </span>
                <span class="float-right mr-3">
                <i
                    class="fas fa-pen clickable"
                    @click="$bvModal.show(modalId)"
                />
            </span>
            </div>
        </div>

        <p v-if="error" class="invalid-feedback d-block ml-3">
            {{ $t('error.general') }}
        </p>


        <b-modal :id="modalId" centered hide-footer>
            <template v-slot:modal-title>
                {{ modalTitle | capitalize }}
            </template>
            <component
                :is="modalComponent"
                :element-data="this.data"
                :is-complication="isComplication"
                @save="save"
                @close="$bvModal.hide(modalId)"
            />
        </b-modal>

        <b-modal :id="modalDeleteId" body-class="delete-modal" centered hide-footer hide-header hide-header-close>
            <div class="text-center">
                <img class="my-3" src="@/assets/icons/error.svg" alt="error">
                <h6 class="mb-3">{{ $t('modalerror.areyousuretodelete') }}</h6>
            </div>

            <div class="float-right">
                <hemocir-button
                    variant="primary"
                    class="mr-3 ok-button"
                    @click="deleteElement"
                >
                    {{ $t('utils.yes') | capitalize }}
                </hemocir-button>

                <hemocir-button
                    variant="secondary"
                    class="cancel-button"
                    @click="$bvModal.hide(modalDeleteId)"
                >
                    {{ $t('utils.no') | capitalize }}
                </hemocir-button>
            </div>
        </b-modal>

        <hr>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import DetailSurgeryBloodTest from "@/components/surgery/detail/elements/DetailSurgeryBloodTest";
    import DetailSurgeryTransfusion from "@/components/surgery/detail/elements/DetailSurgeryTransfusion";
    import DetailSurgeryNovoeight from "@/components/surgery/detail/elements/DetailSurgeryNovoeight";

    export default {
        name: "TimelineGeneralItem",
        props: {
            data: {
                type: Object,
                required: true,
            },
            isComplication: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                error: ''
            };
        },
        computed: {
            ...mapState([
                'bloodTestFields',
                'transfusionFields',
                'novoeightTreatmentFields',
            ]),
            modalId() {
                return 'edit-element-modal-' + this.data.values.id;
            },
            modalDeleteId() {
                return 'edit-element-modal-delete-' + this.data.values.id;
            },
            modalComponent() {
                switch (this.data.type) {
                    case 'bloodtest':
                        return DetailSurgeryBloodTest;
                    case 'transfusion':
                        return DetailSurgeryTransfusion;
                    case 'novoeighttreatment':
                        return DetailSurgeryNovoeight;
                }
                return null;
            },
            modalTitle() {
                switch (this.data.type) {
                    case 'bloodtest':
                        return this.$t('bloodTest.title');
                    case 'transfusion':
                        return this.$t('surgery.transfusion.title');
                    case 'novoeighttreatment':
                        return this.$t('surgery.novoeightTreatment');
                }
                return '';
            },
        },
        methods: {
            ...mapActions([
                'deleteBloodTest',
                'deleteTransfusion',
                'deleteNovoeightTreatment',
                'getSurgery',
            ]),
            deleteElement() {
                switch (this.data.type) {
                    case 'bloodtest':
                        this.deleteBloodTest(this.data.values)
                            .then(this.save)
                            .catch(this.processErrors);
                        break;
                    case 'transfusion':
                        this.deleteTransfusion(this.data.values)
                            .then(this.save)
                            .catch(this.processErrors);
                        break;
                    case 'novoeighttreatment':
                        this.deleteNovoeightTreatment(this.data.values)
                            .then(this.save)
                            .catch(this.processErrors);
                        break;
                    default:
                        break;
                }
            },
            save() {
                this.error = false;
                this.$bvModal.hide(this.modalId);
                this.$emit('save');
            },
            processErrors() {
                this.error = true;
                setTimeout(() => {
                    this.error = false;
                }, 2000);
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "src/custom";

    .item-container {
        @extend .d-flex;
        @extend .align-items-center;
    }

    .buttons {
        @extend .flex-grow-1;
    }

    .d-flex div {
        @extend .mr-3;
    }
</style>